import styled from 'styled-components';

export const Button = styled.button`
  background-color: #eee;
  cursor: pointer;
  font-size: 1em;
  padding: 4px 8px;
  border-radius: 8px;
`;
